import { ContentBox } from "@msuite/ui/app-shell";
import { DataTable } from "@msuite/ui/table";
import React from "react";
import { TeamPicker } from "@/components/pickers/team-picker";
import { useCitadel } from "@/hooks/use-citadel";
import { useMembers } from "@/hooks/use-members";
import { useTeamPicker } from "@/hooks/use-team-picker";
import { columns } from "./table-config";
import { UsersMenu } from "./users-menu";

export function Users() {
	/** Query */
	const { citadel } = useCitadel();

	// The navigation entry is already behind `read User`, so a caller without it arrives here
	// only by typing the address. The list stays behind the same rule rather than firing and
	// toasting a 403 at them. The two entries below read the rule the other way round, because
	// they are opposite states: a query stops on a definitive denial, an entry appears on a
	// definitive grant, and neither moves while the rules are still loading.
	const readIsDenied = !!citadel && citadel.cannot("read", "User");
	const canReadUsers = citadel?.can("read", "User") === true;

	// A team is optional on a person, so everybody without one is in no team tab of this page.
	// "All" and "No team" are the two entries that answer that, and they belong to whoever may
	// see the page at all — a narrower rule would leave those people unreachable again.
	const controller = useTeamPicker(undefined, {
		withAllOption: canReadUsers,
		withUnassignedOption: canReadUsers,
	});
	const { members, queryKey, isLoading, refetch } = useMembers(
		{ teamId: controller.teamIdFilter },
		{ enabled: !readIsDenied },
	);

	/** Render */
	return (
		<React.Fragment>
			<ContentBox>
				<DataTable
					data={members}
					slots={{
						"below-search": () => <TeamPicker controller={controller} />,
					}}
					columns={columns as any}
					persistenceKey="users-table"
					queryKey={queryKey}
					isLoading={isLoading}
					menu={<UsersMenu />}
					refetch={refetch}
				/>
			</ContentBox>
		</React.Fragment>
	);
}
